module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_dg-11d4132ce44c1ac8e4717ddfe5b0ad7e.png";